import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { WhatWeDo } from '../components/WhatWeDo';
import { Testimonials } from '../components/Testimonials';
import { motion } from 'framer-motion';
export function AboutPage() {
  return <main className="bg-white" data-id="element-296">
      <PageBanner title="About Us" subtitle="Learn about our mission and commitment to excellence in secure fingerprinting services." data-id="element-297" />

      <WhatWeDo data-id="element-298" />

      {/* Our Mission Section */}
      <section className="py-24 bg-[#F0F4FF]" data-id="element-299">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-300">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-301">
            <span className="inline-block text-[#4AA6CF] font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-302">
              Our Purpose
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-6 leading-tight" data-id="element-303">
              Our Mission
            </h2>
            <div className="w-16 h-1 bg-[#4AA6CF] rounded-full mx-auto mb-8" data-id="element-304"></div>

            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-305">
              "At Ambient Fingerprinting Solution, our mission is to provide
              secure, efficient, and accurate fingerprinting services that meet
              the highest standards of quality. We are dedicated to serving our
              community with professionalism and integrity."
            </p>
          </motion.div>
        </div>
      </section>

      <Testimonials data-id="element-306" />
    </main>;
}